// import {store1} from '../store/index'

var DataStore = require('../store');
var store = DataStore.default

// const fetchPOST =  () =>{
//     return 'store.state.url.URL_APP'
// }

const fetchPOST = () => {
  return store.state.kamio
}




const getProv = (uraian) => {
  console.log(uraian);
  fetch(store.state.url.URL_DATAMASTER_WILAYAH + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      uraian: uraian
    })
  })
    .then(res => res.json())
    .then(res_data => {
      console.log(res_data)
      store.state.option_provinsi = res_data
    });
}



const getKab = (m_provinsi) => {
  fetch(store.state.url.URL_DATAMASTER_KAB_KOTA + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      m_provinsi: m_provinsi
    })
  })
    .then(res => res.json())
    .then(res_data => {
      // console.log(res_data)
      store.state.option_kabupaten = res_data
    });
}


const getKec = (kab_kota) => {
  fetch(store.state.url.URL_DATAMASTER_KECAMATAN + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      m_kabupaten: kab_kota
    })
  })
    .then(res => res.json())
    .then(res_data => {
      console.log(res_data)
      store.state.option_kecamatan = res_data
    });
}

const getKecSingle = () => {
  fetch(store.state.url.URL_DATAMASTER_KECAMATAN + "listSingle", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    }
  })
    .then(res => res.json())
    .then(res_data => {
      // console.log(res_data)
      store.state.listKec = res_data
    });
}



const getDesKel = (kecamatan) => {
  // console.log(kecamatan)
  fetch(store.state.url.URL_DATAMASTER_DES_KEL + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      kecamatan: kecamatan
    })
  })
    .then(res => res.json())
    .then(res_data => {
      // console.log(res_data)
      store.state.listDesKel = res_data
    });
}














module.exports = {
  fetchPOST: fetchPOST,
  getProv : getProv,
  getKab : getKab,
  getKec : getKec,
  getKecSingle : getKecSingle,
  getDesKel : getDesKel,



}